import React from 'react'

const ProductDetailsQuantityTypeDropdown = ({ id, units, updateUnits, value }) => {
  console.log('units',units)
  const defaultUnit = units[0]
  const selectedValue = value || defaultUnit

  const handleSelectUnit = (unit) => {
    updateUnits(unit)
  }

  return (
    <div className="product-details__qty-type">
      <span id={id} className="visually-hidden">
        Select Your Quantity Type
      </span>
      <div className="product-details__qty-buttons">
        {units.map((unit) => (
          <button
            key={unit.value}
            type="button"
            className={`product-details__qty-button ${selectedValue.value === unit.value ? 'product-details__qty-button--active' : ''}`}
            onClick={() => handleSelectUnit(unit)}
            aria-pressed={selectedValue.value === unit.value}
            style={{height: '35px'}}
          >
            
            {unit.baseUnit ? `${unit.baseUnit} ` : ''}{""}{unit.label}
          </button>
        ))}
      </div>
    </div>
  )
}

{
  /* <div className="prdi__inputs">
                <div className="prdi__inputs-block">
                  <span className="prdi__inputs-label">Size</span>
                  <select className="nice-select prdi__inputs-select">
                    <option>Each</option>
                    <option>2</option>
                    <option>3</option>
                  </select>
                </div> */
}

export default ProductDetailsQuantityTypeDropdown
